export default __webpack_public_path__ + "static/media/blog.654426bf.png";